export default __webpack_public_path__ + "static/product_category_golf-9e82c19fb85f61b66e932497ad65ebac.jpg";